import { render, staticRenderFns } from "./ItemDetailsLink.vue?vue&type=template&id=3751db2a&scoped=true"
import script from "./ItemDetailsLink.vue?vue&type=script&lang=ts"
export * from "./ItemDetailsLink.vue?vue&type=script&lang=ts"
import style0 from "./ItemDetailsLink.vue?vue&type=style&index=0&id=3751db2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3751db2a",
  null
  
)

export default component.exports